import { api } from './api';
import { generateDefaultFinancialYears } from '../utils/financialYearHelper';

const BASE = 'dividend';

// Original CRUD operations
export const listDividends = () => api.get(`${BASE}/`).then(res => res.data);
export const addDividend = (payload) => api.post(`${BASE}/`, payload).then(res => res.data);
export const getDividend = (id) => api.get(`${BASE}/${id}`).then(res => res.data);
export const updateDividend = (id, payload) => api.put(`${BASE}/${id}`, payload).then(res => res.data);

/**
 * GET /api/reports/equity-dividend
 * Fetches equity dividend report for a specific financial year
 * @param {string} financialYear - Format: "YYYY-YYYY" (e.g., "2024-2025")
 * @returns {Promise<Object>} Report data with scrip-wise and monthly breakdown
 */
export const getEquityDividendReport = async (financialYear) => {
  try {
    const res = await api.get(`reports/equity-dividend`, {
      params: { financial_year: financialYear },
    });
    return res.data;
  } catch (error) {
    console.error('Error fetching equity dividend report:', error);
    throw error;
  }
};

/**
 * GET /api/reports/equity-dividend/pdf
 * Downloads equity dividend report as PDF
 * @param {string} financialYear - Format: "YYYY-YYYY"
 * @returns {Promise<Blob>} PDF file blob
 */
export const downloadEquityDividendReportPDF = async (financialYear) => {
  try {
    const res = await api.get(`reports/equity-dividend/pdf`, {
      params: { financial_year: financialYear },
      responseType: 'blob',
    });
    return res.data;
  } catch (error) {
    console.error('Error downloading equity dividend report PDF:', error);
    throw error;
  }
};

/**
 * Gets list of available financial years
 * Format: ["2024-2025", "2023-2024", ...]
 * @returns {Promise<Array>} List of financial years
 */
export const getFinancialYears = async () => {
  try {
    const res = await api.get(`reports/financial-years`);
    return res.data;
  } catch (error) {
    console.error('Error fetching financial years:', error);
    // Return default list if API fails
    return generateDefaultFinancialYears();
  }
};

export { generateDefaultFinancialYears };

export default {
  listDividends,
  addDividend,
  getDividend,
  updateDividend,
  getEquityDividendReport,
  downloadEquityDividendReportPDF,
  getFinancialYears,
  generateDefaultFinancialYears,
};